<template>
  <div id="thank-you" class="thankyou-page">
    <h1 class="blue-text" style="flex: 2; font-size: 32px; margin-bottom: 30px; margin-top: 30px;">
      {{ getTranslation('THANK_YOU_FOR_RESERVATION') }}
    </h1>
    
    <!-- Event info -->
    <h2>{{ eventName }}</h2>    
    <p style="margin-bottom: 2px;">{{ new Date(selectedDate).getDate() + '.' + (new Date(selectedDate).getMonth() + 1) + '.' + (new Date(selectedDate).getYear() + 1900) + ' - ' + selectedTime.time }}</p>    
    <div style="border-bottom: 1px solid rgb(240,240,240); max-width: 200px; margin: auto; margin-bottom: 15px; margin-top: 15px;" />
    
    <!-- Participants -->
    <div style="margin-bottom: 5px;">{{ getTranslation('PARTICIPANTS_THANK_YOU_PAGE') }}</div>    
    <p style="margin-top: 0px; margin-bottom: 5px;" v-for="(value, key) in participants" :key="key">
      {{ value.title }} : {{ value.amount }}
    </p>
    <div style="border-bottom: 1px solid rgb(240,240,240); max-width: 200px; margin: auto; margin-bottom: 15px; margin-top: 15px;" />
    
    <!-- Additionals -->
    <div v-if="(selectedPickup && ( selectedPickup.selectionType === 'PRESELECTED' || formValues['checkbox-pickup-wanted']) ) || (selectedDropoff && ( selectedDropoff.selectionType === 'PRESELECTED' || formValues['checkbox-dropoff-wanted']) ) || Object.values(filterExtras(formValues)).filter(_ => _).length > 0">
      <div style="margin-bottom: 5px;">{{ getTranslation('ADDITIONALS') }}</div>
  
      <p v-if="selectedPickup && ( selectedPickup.selectionType === 'PRESELECTED' || formValues['checkbox-pickup-wanted'])" style="margin-top: 0px; margin-bottom: 5px;">
        {{ getTranslation('PICK_UP') }}
      </p>
    
      <p v-if="selectedDropoff && ( selectedDropoff.selectionType === 'PRESELECTED' || formValues['checkbox-dropoff-wanted'])" style="margin-top: 0px; margin-bottom: 5px;">
        {{ getTranslation('DROP_OFF') }}
      </p>

      <div v-for="(value, name) in selectedExtras" :key="name">          
        <p v-if="value" style="margin-top: 0px; margin-bottom: 5px;">
          {{ value.title }} 
        </p>
      </div>
    </div>

    <!-- Close button -->
    <div style="border-bottom: 1px solid rgb(240,240,240); max-width: 200px; margin: auto; margin-bottom: 15px; margin-top: 15px;" />    
    <button class="return-button" v-on:click="goToActivity">{{ getTranslation('CLOSE') }}</button>
    <div style="height: 100px;" />

  </div>
</template>

<script>
export default {
  name: 'ThankYouPage',
  props: {
    eventName: String,
    totalDueAsText: String,
    participants: Object,
    prebookingId: String,
    selectedDate: String,
    selectedTime: Object,
    getTranslation: Function,
    selectedRate: Object,
    selectedPickup: Object,
    selectedDropoff: Object,
    selectedExtras: Object,
    filterExtras: Function,
    formValues: Object,
    getPriceById: Function,
    currencyRegexSum: Function,
    combinedAdditionals: Function,
    pickup: Object,
    dropoff: Object
  },
  methods: {
    goToActivity: function () {
      window.location = window.location.href.split("?")[0];
    }
  }
}
</script>

<style scoped>
.thankyou-page {
  animation-name: fade-in;
  animation-duration: 2s;
  text-align: center;
}
.return-button {
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: 0px;
  background-color: #0092C8;
  color: white;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
}
.return-button:hover {
  opacity: 0.8;
}
</style>
